/*=========================================================================================
  File Name: moduleHistoryActions.js
  Description: Partner Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import "firebase/auth";
import axios from "@/axios";
import Vue from "vue";
import VueCookies from "vue-cookies";
Vue.use(VueCookies);

export default {
  fetchStaffByPartnerId({ commit }, id) {
    return new Promise((resolve, reject) => {
      axios
        .get("/partners/staff-list/" + id)
        .then(res => {
          return resolve(res);
        })
        .catch(err => {
          return reject(err.response);
        });
    });
  },
  fetchStaffDetailsById({ commit }, id) {
    return new Promise((resolve, reject) => {
      axios
        .get("/partners/staff/" + id)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  updateStaffDetailsById({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios
        .patch("/partners/staff/" + data.id, data.data, data.config)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },


  createStaff({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios
        .post("partners/staff", data.data, data.config)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  deleteStaff({ commit }, id) {
    return new Promise((resolve, reject) => {
      axios
        .delete("/partners/staff/" + id)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
};
